import { css, styled } from 'styled-components'
import { brandConfig } from '../../../config/brandConfig'
import CashinCashbackIcon from '../../../images/cashback/icon_cashback.svg'

export const StyledCashbackContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 24px;
  gap: 10px;
  color: ${brandConfig.colors.white.main};
  overflow-y: auto;
  overflow-x: hidden;

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      height: ${$minHeight}px;
    `}
`

export const StyledProgressContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  margin-bottom: 16px;

  p {
    margin-bottom: 6px;
    margin-top: 10px;
    color: ${brandConfig.colors.white.main};
    text-align: left;
  }
`

export const StyledProgress = styled.div`
  background: url(${CashinCashbackIcon}) 50% no-repeat;
  background-size: 75px;
  width: 130px;

  .CircularProgressbar {
    margin: 0.5rem 0;
  }
`

export const StyledTimerContainer = styled.div`
  min-width: 120px;
`

export const CashbackCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 15px;
  padding-bottom: 58px;
  scrollbar-width: none;
  overflow-y: hidden;
  margin: 0 -24px;

  &::-webkit-scrollbar {
    display: none;
  }

  & > *:first-child {
    margin-left: 24px;
  }

  & > *:last-child {
    margin-right: 24px;
  }

  > div {
    min-width: calc(100% - 48px);
  }
`

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1em 0 3em;
`

export const EmptyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
  min-height: 100%;
  width: 100%;

  p {
    margin: 35px 0;
    text-align: center;
  }

  a {
    font-size: 14px;
    color: ${brandConfig.colors.accentColors.secondary.main};
    text-decoration: none;
    margin-bottom: 47px;
  }

  button:disabled {
    background-color: ${brandConfig.colors.dominantGrey.main};
    color: ${brandConfig.colors.darkGreys[2].main};
  }

  img {
    padding-top: 40px;
  }
`

export const StyledNoticeText = styled.span`
  color: ${brandConfig.colors.lightGreys[4].main};
  font-size: 14px;
  margin-bottom: 10px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  width: 100%;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
